import styled from "styled-components";

import * as DrawerLayout from "Components/DrawerLayout";
import { breakpoints } from "Libs/theme";

export const Root = styled(DrawerLayout.Root)`
  margin: 0 -24px;
  min-height: 1px;
  flex: 1;
  flex-direction: column;

  @media (min-width: ${breakpoints[1]}) {
    margin: 0 -40px;
    flex-direction: row;
  }
`;

export const Drawer = styled(DrawerLayout.Drawer)`
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;

  @media (min-width: ${breakpoints[1]}) {
    width: 356px;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const Content = styled(DrawerLayout.Content)`
  padding-left: 24px;
  padding-right: 24px;

  @media (min-width: ${breakpoints[1]}) {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export { Footer, Separator, Block } from "Components/DrawerLayout";
